"use strict";

/**
 * Snap-Konstanten
 *
 * @enum {string}
 */
gc.gis.control.GCSnapConstants = {
	/**
	 * An Stützpunkten fangen.
	 */
	SNAP_VERTEX: 1,
	/**
	 * An Kanten fangen.
	 */
	SNAP_EDGE: 2
};

/**
 * Snap-Events
 *
 * @enum {string}
 */
gc.gis.control.GCSnapEvent = {
	/**
	 * @event gc.gis.control.GCSnapEvent#props:changed
	 */
	PROPS_CHANGED:              'props:changed'
};

/**
 * Control zur Bereitstellung einer Snapfunktion für Vektorlayer.
 *
 * @class
 * @abstract
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCSnap = function(options)
{
	gc.gis.control.GCAbstractMapControl.call(this, options);

	/**
	 * Pixel-Toleranz für die Snapfunktion.
	 * @type {number}
	 */
	this.PIXEL_TOLERANCE = 12;

	/**
	 * Aktueller Snap-Modus.
	 * @type {number}
	 * @private
	 */
	this._snapMode = gc.gis.control.GCSnapConstants.SNAP_EDGE | gc.gis.control.GCSnapConstants.SNAP_VERTEX;

	/**
	 * Liste von Controls, die durch die Snapfunktion überwacht werden.
	 * @type {Array}
	 * @private
	 */
	this._observeControls = [];
};
gc.gis.control.GCSnap.prototype = Object.create(gc.gis.control.GCAbstractMapControl.prototype);

/**
 * Liefert die Konfiguration für den Formularer-Renderer, welcher die möglichen Eigenschaften der Snapfunktion zur
 * Verwendung innerhalb von Modulen enthält.
 *
 * @return Array
 * @method
 * @public
 */
gc.gis.control.GCSnap.prototype.getFormConfig = function()
{
	var self = this;
	var controls = [];

	controls[controls.length] = {
		label: 'Fangfunktion',
		name: 'snap_control_activate',
		tooltip: 'Schaltet die Fangfunktion ein oder aus.',
		type: 'checkbox',
		initFunc: function (config) {
			self._observeControls.push(config);
			self.on(gc.gis.control.GCSnapEvent.PROPS_CHANGED, self, function (snap_props) {
				self._onSnapPropsChanged(snap_props, config);
			});
		},
		change: function (evt, form, control) {
			self.enable(form.getValue('snap_control_activate'));
		},
		subForm: {
			controls: [
				{
					label: 'nur Stützpunkte fangen',
					name: 'snap_control_vertext',
					tooltip: 'Schränkt die Fangfunktion auf Stützpunkte ein.',
					type: 'checkbox',
					initFunc: function (config) {
						self.on(gc.gis.control.GCSnapEvent.PROPS_CHANGED, self, function (snap_props) {
							self._onSnapPropsChanged(snap_props, config);
						});
					},
					change: function (evt, form, control) {
						if (form.getValue('snap_control_vertext'))
						{
							self.setSnapMode(gc.gis.control.GCSnapConstants.SNAP_VERTEX);
						}
						else
						{
							self.setSnapMode(gc.gis.control.GCSnapConstants.SNAP_VERTEX
								| gc.gis.control.GCSnapConstants.SNAP_EDGE);
						}
					}
				}
			]
		}
	};

	return controls;
};

/**
 * Aktiviert oder deaktiviert die Fangfunktion.
 *
 * @param {boolean} active
 * @method
 * @public
 */
gc.gis.control.GCSnap.prototype.enable = gc.gis.abstractMethod;

/**
 * Zeigt an, ob die Fangfunktion aktiviert ist.
 */
gc.gis.control.GCSnap.prototype.isEnabled = gc.gis.abstractMethod;

/**
 * Setzt den Modus der Fangfunktion auf Stützpunkte und/oder Kanten.
 *
 * @param {number} mode
 * @method
 * @public
 */
gc.gis.control.GCSnap.prototype.setSnapMode = gc.gis.abstractMethod;

/**
 * Initialisiert die Events für die Snapfunktion.
 *
 * @protected
 */
gc.gis.control.GCSnap.prototype._initEvents = function()
{
	var self = this;

	// Interaktion (de-)aktivieren, wenn Panel (in-)aktiv
	gc.gis.iface.ui.sidebar.on(gc.gis.ui.GCSidebarEvent.CONTENT_CHANGED, this, function(evt) {
		var newValue = false,
			oldValue = false,
			i, ii;

		if (self.isEnabled())
		{
			for (i = 0, ii = self._observeControls.length; i < ii; i++)
			{
				if (!newValue && evt.newValue)
				{
					newValue = evt.newValue.getElement().find(self._observeControls[i].getElement()).length > 0;
				}

				if (!oldValue && evt.oldValue)
				{
					oldValue = evt.oldValue.getElement().find(self._observeControls[i].getElement()).length > 0;
				}
			}

			// wenn Snap aktiv ist, beim Verlassen des Moduls deaktivieren
			// Optimierung: beim anschließenden Aktivieren ggf. automatisch wieder anschalten
			// + letzten Zustand vor der Deaktivierung in Member merken und
			if (!newValue && oldValue)
			{
				self.enable(false);
			}
		}
	});
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn sich die Eigenschaften der Fangfunktion geändert haben.
 *
 * Insbesondere wird diese Methode zur Aktualisierung der Nutzeroberfläche benutzt.
 *
 * @param {Object} snap_props
 * @param {Object} element_config
 * @protected
 */
gc.gis.control.GCSnap.prototype._onSnapPropsChanged = function(snap_props, element_config)
{
	var elem = element_config.getElement();
	switch (elem.attr('name'))
	{
		case 'snap_control_activate':
			if (snap_props.enabled !== elem.prop('checked'))
			{
				elem.prop('checked', snap_props.enabled);
				elem.trigger('change'); // change event triggern (Subform ein-/ausblenden)
			}
			break;
		case 'snap_control_vertext':
			if ( (snap_props.mode === gc.gis.control.GCSnapConstants.SNAP_VERTEX && !elem.prop('checked'))
				|| (snap_props.mode !== gc.gis.control.GCSnapConstants.SNAP_VERTEX && elem.prop('checked')) )
			{
				elem.prop('checked', !elem.prop('checked'));
			}
			break;
	}
};

/**
 * Löst ein Event aus, welches Änderungen an den Eigenschaften der Fangfunktion anzeigt.
 *
 * @protected
 */
gc.gis.control.GCSnap.prototype._fireSnapPropsChanged = function()
{
	this._fireEvent(gc.gis.control.GCSnapEvent.PROPS_CHANGED,{
		enabled: this.isEnabled(),
		mode: this._snapMode
	});
};